import Vue from 'vue'

export default {
  login (data) {
    return Vue.axios.post('/api/v1/auth/login', data).then(response => {
      return response.data
    })
  },
  loadUser() {
    return Vue.axios.get('/api/v1/auth/user').then(response => {
      return response.data
    })
  },
  refreshToken(refreshToken) {
    return Vue.axios.post('/api/v1/auth/refresh-token', {
      refreshToken: refreshToken
    }).then((response) => {
      return response.data
    })
  }
}
